import { atom } from 'recoil';
import { Document } from '../utils/interfaces';
import { DocumentProps } from 'components/ListDocumentsViewer/utils/interfaces';

interface ListPdfsStateProps {
  listPdfs: DocumentProps[];
  isLoading: boolean;
}

export const documentsBillingCenter = atom<Document[]>({
  key: 'documentsBillingCenter',

  default: [],
});

export const documentIdMapState = atom<Record<number, number>>({
  key: 'documentIdMapStateBillingCenter',
  default: {},
});

export const listPdfsState = atom<ListPdfsStateProps>({
  key: 'listPdfs',
  default: {
    listPdfs: [],
    isLoading: false,
  },
});
